import { enumFieldDisplayMode, kOCNDarkGrayColor } from "../constants";
import { GetFieldLabel } from "./GetFieldLabel";
import { SVG_DrawCircle } from "./SVG_DrawCircle";
import { SVG_DrawFilledCircle } from "./SVG_DrawFilledCircle";
import { SVG_DrawLegend } from "./SVG_DrawLegend";
import { SVG_ShiftX } from "./SVG_ShiftX";
import { SVG_ShiftY } from "./SVG_ShiftY";
import { SVG_DrawText } from "./SVG_DrawText";
import { SVG_DrawSlices } from "./SVG_DrawSlices";

export function SVG_DrawCellChart(cell, r, doLegend, txtFillStyle, altCanvasElement) {
  var cellDesc = cell.GetCellDesc();
  cellDesc.BuildPieChartContent();
  var pieSections = cellDesc.fPieSections;
  var width = cell.GetWidth();
  var height = cell.GetHeight();
  var strokeStyle = kOCNDarkGrayColor;

  var radius = width / 2.5 - 4;
  if (radius < 0) radius = 0;
  var x = cell.fHorzOffset + Math.floor(width / 2);
  var y = cell.fVertOffset + Math.floor(height * 0.45);
  x = SVG_ShiftX(x, altCanvasElement);
  y = SVG_ShiftY(y, altCanvasElement);

  var displayMode = cell.GetCellDesc().GetFieldDisplayMode();
  var doLabel = displayMode !== enumFieldDisplayMode.FieldOnly;
  var myField = cell.GetField();
  if (doLabel && myField) {
    var fontSize = cell.GetFontSize();
    var fontFamily = cell.GetFontName();
    var label = GetFieldLabel(myField);
    SVG_DrawText(
      label,
      x,
      y - radius - fontSize * 1.5,
      txtFillStyle,
      fontFamily,
      fontSize,
      true,
      false,
      false,
      "center",
      "top",
      false,
      altCanvasElement
    );
  }
  if (pieSections.length === 0) {
    SVG_DrawCircle(x, y, radius, strokeStyle, 1, altCanvasElement);
  } else if (pieSections.length === 1) {
    SVG_DrawFilledCircle(
      x,
      y,
      radius,
      pieSections[0]["color"],
      1,
      pieSections[0]["color"],
      altCanvasElement
    );
  } else {
    SVG_DrawSlices(x, y, radius, pieSections, altCanvasElement);
  }
  if (doLegend) SVG_DrawLegend(x, y, width, height, radius, pieSections, altCanvasElement);
}
